import $ from 'jquery';
import debounce from 'just-debounce';
import CurrencyConverter from 'shopify-currency-converter';
import $script from 'scriptjs';
import MobileNav from '../snippets/NavMobile';
import DesktopNav from '../snippets/NavDesktop';
import Meganav from '../snippets/Meganav';
import Layout from '../Layout';

export default class HeaderStaticSection {
  constructor(section) {
    this.section = section;
    this.$el = $(section.el);
    this.$mobileNavToggle = this.$el.find('[data-mobilenav-toggle]');
    this.currency = section.data.currency;
    this.$switcher = $('[data-currency-converter]');

    // Sub-components
    this.mobileNav = new MobileNav(this.$el.find('.mobilenav'));
    this.nav = new DesktopNav(this.$el.find('.site-navigation'), section.postMessage);

    this.$megaNavTriggers = $(this.$el.find('.site-navigation')).find('[data-meganav-trigger]');
    this.$megaNavs = this.$el.find('[data-meganav]');
    this.megaNavs = [];

    this.$megaNavTriggers.each((key, megaNavTrigger) => {
      const $megaNavTrigger = $(megaNavTrigger);
      const trigger = $megaNavTrigger.data('meganav-trigger');
      const $megaNav = this.$megaNavs.filter(`[data-meganav="${trigger}"]`);
      this.megaNavs.push(new Meganav($megaNav.get(0), this.section.postMessage, trigger));
    });

    // Event handlers
    this.events = [
      // Open mobile nav button
      // Mobile safari will only allow us to focus the actual search input
      // programaticaly if we trigger it from an input field.
      this.$mobileNavToggle.on('click.header', event => {
        event.preventDefault();
        this.mobileNav.open();
      }),
      $(window).on('resize.header', debounce(() => this._repositionNav(), 16, true, true)),
    ];

    this.layoutHandler = this.onBreakpointChange.bind(this);
    Layout.onBreakpointChange(this.layoutHandler);

    if (this.currency.enable) {
      const $scripts = $('[data-scripts]');

      $script($scripts.data('shopify-currencies'), () => {
        $script($scripts.data('shopify-jquery-currencies'), () => {
          this._converter();
        });
      });
    }

    setTimeout(() => {
      this._repositionNav()
    }, 100);
  }

  _repositionNav() {
    this.$el.removeClass('site-navigation-flex');

    if (Layout.isBreakpoint('S')) {
      return;
    }

    this.$el.toggleClass('site-navigation-flex', !this.nav.isSingleLine());
  }

  _converter() {
    CurrencyConverter.init({
      switcherSelector: '[data-currency-converter]',
      priceSelector: '.money',
      shopCurrency: this.currency.shopCurrency,
      defaultCurrency: this.currency.defaultCurrency,
      displayFormat: this.currency.displayFormat,
      moneyFormat: this.currency.moneyFormat,
      moneyFormatNoCurrency: this.currency.moneyFormatNoCurrency,
      moneyFormatCurrency: this.currency.moneyFormatCurrency,
    });

    this.$switcher.on('change.converter', event => {
      CurrencyConverter.setCurrency(event.currentTarget.value);
    });
  }

  onSectionUnload() {
    this.nav.unload();
    this.mobileNav.unload();
    this.events.forEach($el => $el.off('.header'));

    Layout.offBreakpointChange(this.layoutHandler);

    if (this.currency.enable) {
      this.$switcher.off('change.converter');
    }

    this.megaNavs.forEach(megaNav => megaNav.onSectionUnload());
  }

  onSectionMessage(name, data) {
    if (name === 'mobilenav:open') this.mobileNav.open();
    if (name === 'mobilenav:close') this.mobileNav.close();
    if (name === 'product:add-to-cart') {
      $('[data-cart-item-count]', this.$el).text(data.response.item_count);
    }

    if (name === 'nav:close-all') this.nav.closeAll();

    this.megaNavs.forEach(megaNav => megaNav.onSectionMessage(name, data));
  }

  onBreakpointChange() {
    if (Layout.isBreakpoint('M') || Layout.isBreakpoint('L')) {
      this.mobileNav.close();
    }
  }
}
